export default {
  list(context) {
    return window.axios.get("/accounts/refund-requests").then(({ data }) => {
      const items = Array.isArray(data) ? data : data.results || [];
      context.commit("setItems", items);
      return items;
    });
  },

  create(context, { product_id, reason, bank_account }) {
    const payload = { product_id, reason };
    if (bank_account) {
      payload.bank_account = bank_account;
    }
    return window.axios
      .post("/accounts/refund-requests", payload)
      .then(({ data }) => data);
  },

  listBanks(context) {
    return window.axios
      .get("/accounts/refund-requests/banks")
      .then(({ data }) => {
        const banks = Array.isArray(data) ? data : data.results || [];
        context.commit("setBanks", banks);
        return banks;
      });
  }
};
